import React from 'react'
import { Link } from 'gatsby'
import { Box, Heading, Button } from 'theme-ui'
import Section from '@components/Section'

/**
 * Shadow me to add your own content
 */

const styles = {
  heading: {
    mb: 4,
    span: {
      color: `omegaDark`
    },
    color: 'alpha',
    marginBottom: '2%'
  },
  running: {
    color: `omegaDark`,
    fontWeight: `body`,
    width: `5/6`,
  }
}

const HeroContent = () => (
  <>
    <Section>
      <Heading variant='h1' sx={styles.heading}>
        Bite-Sized<span> Knowledge</span><br></br> in Minutes.
      </Heading>
      <Heading variant='h2' sx={styles.running}>
        Capturing complex ideas into brief summaries not only helps me grasp them better but also makes it easier for others to engage with new concepts. I’m excited to share these quick reads that offer key takeaways and insights—perfect for busy minds on the go!"
      </Heading>
      <Heading variant='h3' sx={styles.running}>
        Larissa Wicker
      </Heading>
    </Section>
    <Box variant='buttons.group' sx={styles.buttons}>
      {/*}
      <Button as={Link} to='/'>
        Start Learning
      </Button>
      */}
      <Button variant='white' as={Link} to='/about' style={{ marginTop: '15px' }}>
        About Me
      </Button>
      {/* <Button variant='white' as={Link} to='https://lytevapes.com' style={{ marginTop: '15px' }}> */}
      {/*   My Business */}
      {/* </Button> */}
    </Box>
  </>
)

export default HeroContent
